import type {CentralPaneName} from '@libs/Navigation/types';

const CENTRAL_PANE_TO_RHP_MAPPING: Partial<Record<CentralPaneName, string[]>> =
  {};

export default CENTRAL_PANE_TO_RHP_MAPPING;
